import React from "react";
import { useQueryParamValue } from "./useQueryParamValue";

export interface Config {
  userId: string;
  isWebView: boolean;
}

export const ConfigContext = React.createContext<Config>({
  userId: "",
  isWebView: false,
});

interface Props {
  children?: React.ReactNode;
}

const parseUserId = (searchParam: string): string | undefined => {
  return searchParam || undefined;
};

const parseIsWebview = (searchParam: string): boolean | undefined => {
  return searchParam === "true" || undefined;
};

export function ConfigContextProvider(props: Props) {
  const { children } = props;
  const userId = useQueryParamValue<string>("userId", parseUserId, "");
  const isWebView = useQueryParamValue<boolean>(
    "webview",
    parseIsWebview,
    false
  );

  const config = {
    userId,
    isWebView,
  };

  return (
    <ConfigContext.Provider value={config}>{children}</ConfigContext.Provider>
  );
}
